// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPlayer_container__9gwX5","player":"VideoPlayer_player__hCBr4"};